import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';

const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  return response.data.result.assets.map((v) => {
    return {
      ...v.content.Content,
      latestModifiedDate: v.metadata.LatestModifiedDate,
      id: v.id,
    };
  });
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = () => {
  const url = CMSAPI_INDEX(
    config.lscsPath,
    '(TeamSite/Templating/DCR/Type:Announcement)',
    0,
    5,
    config.cmsProjectName,
    false,
  );
  return axiosAdapter({
    url,
  });
};

const getAnnouncement = () => {
  return (dispatch) => {
    dispatch(requestFetch());
    return fetchData()
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getAnnouncement };
